import React, { useMemo } from 'react';

import useE164 from '../../utils/E164';

/**Formats a phone number in the specified format, or derives one from the country code.
 * @param {Object} props Incoming JSX attributes.
 * @param {boolean} props.link If true, creates a link for calling the specified phone number.
 * @param {string} props.mask Optional custom mask to apply to the rendered phone number.
 * @param {string} props.phoneNumber Phone number in {@link https://en.wikipedia.org/wiki/E.164 E.164 format}.
 */
function E164(props) {
    const { normalize } = useE164();

    const number = useMemo(() => {
        return normalize(props.phoneNumber);
    }, [props.phoneNumber, normalize]);

    return props.link ? (
        <a
            className="E164-component"
            href={`tel:${props.phoneNumber}`}
        >
            {number}
        </a>
    ) : (
        <span className="E164-component">{number}</span>
    );
}

export default E164;
